import script from "./UiDropdownGroup.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20object%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes"
export * from "./UiDropdownGroup.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20object%2C%20P%20extends%20keyof%20T%2C%20L%20extends%20keyof%20T%2C%20M%20extends%20Modes"

const __exports__ = script;

export default __exports__